/** alias mapping for keyboard keys **/

export default {

  // special keys
  'enter': '13',
  'tab': '9',
  'delete': '8',
  'backspace': '8',
  'space': '32',
  'esc': '27',
  'escape': '27',

  // modifier keys
  'control': '17',
  'ctrl': '17',
  'alt': '18',
  'option': '18', // on mac
  'caps': '20',
  'caps-lock': '20',
  'capslock': '20',

  'windows': '91', // windows key
  'left-command': '91', // left command key on mac layout
  'left-cmd': '91',
  'search': '91', // on chromebook
  'menu': '93', // windows menu
  'right-command': '93', // right command key on mac layout
  'right-cmd': '93',

  // arrow keys
  'left' : '37',
  'up' : '38',
  'right' : '39',
  'down' : '40',

  // alpha keys, in order of keyboard qwerty layout
  'q': '81',
  'w': '87',
  'e': '69',
  'r': '82',
  't': '84',
  'y': '89',
  'u': '85',
  'i': '73',
  'o': '79',
  'p': '80',
  'a' : '65',
  's' : '83',
  'd' : '68',
  'f' : '70',
  'g' : '71',
  'h' : '72',
  'j' : '74',
  'k' : '75',
  'l' : '76',
  'z' : '90',
  'x' : '88',
  'c' : '67',
  'v' : '86',
  'b' : '66',
  'n' : '78',
  'm' : '77',
}



// WEBPACK FOOTER //
// ./src/input/keyCodeMap.js